module.exports = __webpack_public_path__ + "media/images/star-618d11e122cbca3f8e9ed45831d89520.png";